import axios from "axios";

// const axiosInstance = axios.create({
//   baseURL: "http://127.0.0.1:4600/api/v1/",
// });

const axiosInstance = axios.create({
  baseURL: "https://api.gonetgroup.icu/api/v1/",
});

/** Ensures loader data always has expected shape when the request fails or the body omits `data`. */
function normalizeAxiosError(err, dataDefaults) {
  const raw = err.response?.data;
  if (raw && typeof raw === "object") {
    return {
      status: raw.status ?? "error",
      message: raw.message,
      ...(raw.count !== undefined ? { count: raw.count } : {}),
      data: {
        ...dataDefaults,
        ...(typeof raw.data === "object" && raw.data !== null ? raw.data : {}),
      },
    };
  }
  return {
    status: "error",
    message: err.message || "Something went wrong",
    data: dataDefaults,
  };
}

export const createAccount = async (jwt, data) => {
  try {
    const res = await axiosInstance({
      method: "POST",
      url: "users/signUp",
      data,
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const logIn = async (data) => {
  try {
    const res = await axiosInstance({
      method: "POST",
      url: "users/loginAdmin",
      data,
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const verifyLoginTwoFactor = async (data) => {
  try {
    const res = await axiosInstance({
      method: "POST",
      url: "users/verifyLoginAdminTwoFactor",
      data,
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const getAllAccounts = async (jwt) => {
  try {
    const res = await axiosInstance({
      method: "GET",
      url: "users",
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    });
    return res.data;
  } catch (err) {
    return normalizeAxiosError(err, { users: [] });
  }
};

export const getOneAccount = async (jwt, id) => {
  try {
    const res = await axiosInstance({
      method: "GET",
      url: `users/${id}`,
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    });
    return res.data;
  } catch (err) {
    return normalizeAxiosError(err, { user: null });
  }
};

export const updateAccount = async (jwt, data, id) => {
  try {
    const res = await axiosInstance({
      method: "PATCH",
      url: `users/${id}`,
      data,
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const deleteAccount = async (jwt, id) => {
  try {
    const res = await axiosInstance({
      method: "DELETE",
      url: `users/${id}`,
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const getTransactions = async (jwt) => {
  try {
    const res = await axiosInstance({
      method: "GET",
      url: `transactions/getTransactions`,
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    });
    return res.data;
  } catch (err) {
    return normalizeAxiosError(err, { transactions: [] });
  }
};

export const deleteTransaction = async (jwt, id) => {
  try {
    const res = await axiosInstance({
      method: "DELETE",
      url: `transactions/${id}`,
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const createTransaction = async (jwt, data) => {
  try {
    const res = await axiosInstance({
      method: "POST",
      url: `transactions/create`,
      data,
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};

export const reverseTransaction = async (jwt, id) => {
  try {
    const res = await axiosInstance({
      method: "PATCH",
      url: `transactions/reverse/${id}`,
      headers: {
        authorization: `Bearer ${jwt}`,
      },
    });
    return res.data;
  } catch (err) {
    return err.response.data;
  }
};
